import React from "react"
import { Container } from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import NotificationsTable from "./table"

const Notifications = () => {
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title={"Notifications"} breadcrumbItem={"Roles"} />
          <NotificationsTable />
        </Container>
      </div>
    </>
  )
}

export default Notifications
